export var source_application_catalog = { "uid": "source_application_catalog", "fields": { "title": { "defaultValue": "" } } };
